import React, {useContext} from "react";
import {UserContext} from "@web/hooks/context";
// import LineReservationManager from "@web/components/LineReservationManager";
import Splash from "@web/components/Splash";

const RequireLine = (props) => {
  const [userId, h, u, claims] = useContext(UserContext)

  if (!userId) return null;

  return claims?.data?._h ?
    props.children :
    <Splash />;
}

export default RequireLine
